import * as constants from '../constants';

const extractLanguage = (language) => language.toLowerCase().split(/[_-]+/)[0];

const language = (navigator.languages && navigator.languages[0]) ||
                     navigator.language ||
                     navigator.userLanguage ||
                     'en';

const INITIAL_STATE = {
    current: extractLanguage(language),
};

export default function surveyReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.INSTANCE_SUCCESS:
            return Object.assign({}, state, {current: extractLanguage(action.payload.instance.locale)});
        case constants.SURVEY_SUCCESS:
            return Object.assign({}, state, {current: extractLanguage(action.payload.item.locale)});
    }
    return state;
}
